module.exports = __webpack_public_path__ + "static/img/ad-4.53f5916.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ad-4.png
// module id = 1FHE
// module chunks = 0